// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"796":"e783d8a9","824":"232a6268"}[chunkId] + ".chunk.css";
};